import { render } from "./ProfileStatus.vue?vue&type=template&id=278fb0de&scoped=true"
import script from "./ProfileStatus.vue?vue&type=script&lang=js"
export * from "./ProfileStatus.vue?vue&type=script&lang=js"

import "./ProfileStatus.vue?vue&type=style&index=0&id=278fb0de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278fb0de"]])

export default __exports__